export const experienceData = [
    {
        id: 1,
        company: 'OneTap Technologies',
        jobtitle: 'FullStack Developer',
        startYear: 'Sep 2023',
        endYear: 'Present'
    },
    {
        id: 2,
        company: 'Ghion Technologies',
        jobtitle: 'FullStack Developer',
        startYear: '2021',
        endYear: '2023'
    },
    {
        id: 3,
        company: 'Dr. Iyob Hailu Consultancy',
        jobtitle: 'Project Manager',
        startYear: '2020',
        endYear: '2022'
    },
]